import React from 'react';

// Parsa @[username](slug) in elementi React cliccabili
export function renderCommentBody(body: string): React.ReactNode {
  const parts = body.split(/(@\[[^\]]+\]\([^)]+\))/g);
  return parts.map((part, i) => {
    const match = part.match(/^@\[([^\]]+)\]\(([^)]+)\)$/);
    if (match) {
      const [, username, slug] = match;
      return (
        <a
          key={i}
          href={`/users/${slug}`}
          className="text-primary font-medium hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          @{username}
        </a>
      );
    }
    return part;
  });
}
